import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const apiModule = {
    namespaced: true,
    state: {
        dashboards: [],
        isLoadedDashboards: false,
        dashboardsLoadFailure: null,
        userDashboards: [],
        isLoadedUserDashboards: false,
        userDashboardsLoadFailure: null,
        gameTypes: [],
        isLoadedGameTypes: false,
        gameTypesLoadFailure: null,
        userGameTypes: [],
        isLoadedUserGameTypes: false,
        userGameTypesLoadFailure: null,
    },
    mutations,
    actions,
    getters
};

export default apiModule;
